export enum MetricTypeEnum {
    GOOGLE_ANALYTICS = 'GOOGLE_ANALYTICS',
    ADJUST = 'ADJUST',
    APPS_FLYER = 'APPS_FLYER'
}